import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import "./PimpinanKampus.css";

const pimpinanData = [
  {
    nama: "Prof. Dr. H. Sarjon Defit, S.Kom, MSc",
    jabatan: "Rektor",
    foto: "/pimpinan/Rektor.jpg",
    detail: {
      ttl: "Padang Sibusuk / 07 Agustus 1970",
      nidn: "1007087002",
      jenisKelamin: "Laki-laki",
      agama: "Islam",
      email: "sarjond@yahoo.co.uk",
      fakultas: "Ilmu Komputer / Sistem Informasi",
      pekerjaan: "Dosen / Rektor UPI-YPTK Padang",
      pangkat: "Guru Besar / IVc",
      riwayatPendidikan: [
        "SD Inpres I 3/76 Padang Sibusuk, tamat tahun 1983",
        "Madarasah Tsanawiyah Negeri Padang Sibusuk - tamat tahun 1986",
        "Madarasah Aliyah Negeri Koto Baru Padang Panjang - tamat tahun 1989",
        "STMIK “YPTK” Padang - tamat tahun 1993",
        "Universiti Teknologi Malaysia (S2) - tamat tahun 1998",
        "Universiti Teknologi Malaysia (S3) - tamat tahun 2003",
      ],
    },
  },
  {
    nama: "Dr. Ir. Sumijan, M.Sc",
    jabatan: "Pembantu Rektor I",
    foto: "/pimpinan/wr-1.jpg",
    detail: {
      ttl: "Nganjuk / 07 Mei 1966",
      nidn: "0005076607",
      jenisKelamin: "Laki-laki",
      jabatanFungsional: "Lektor",
      fakultas: "Ilmu Komputer",
      identitas: "196605071994031004",
      scopusID: "57194787076",
      sintaID: "5977501",
      orcidID: "0000-0002-9932-4325",
      researcherID: "I-9167-2017",
      googleScholar: "XxDV_WsAAAAJ",
      pangkat: "Lektor Kepala / IVa",
      researchGate:
        "https://www.researchgate.net/profile/Sumijan_Sumijan",
      riwayatPendidikan: [
          "S1 Sarjana Sistem Informasi (UPI-YPTK Padang)",
          "S2 Magister Sistem Informasi (University Teknologi Malaysia)",
          "S3 Doktor Teknologi Informasi (Universitas Gunadarma Jakarta)",
      ],
      mataKuliah: [
        "Pengolahan Citra Digital Bidang Medis",
        "Audit Teknologi Informasi",
        "Perencanaan Infrastruktur",
        "Multimedia dan Computer Vision",
        "Machine Learning dan Deep Learning",
      ],
    },
  },
  {
    nama: "Dr. Hanna Pratiwi, SE, MM",
    jabatan: "Pembantu Rektor II",
    foto: "/pimpinan/wr-2.jpg",
  },
  {
    nama: "Dr. Elvis Wandi, SE, MM, Ak, CA",
    jabatan: "Pembantu Rektor III",
    foto: "/pimpinan/wr-3.jpg",
  },
  {
    nama: "Dr. Jhon Veri, S.Kom, MM, M.Kom",
    jabatan: "Pembantu Rektor IV",
    foto: "/pimpinan/wr-4.jpg",
  },
];

function PimpinanKampus() {
  const [selectedPimpinan, setSelectedPimpinan] = useState(pimpinanData[0]);

  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  const handlePimpinanSelect = (pimpinan) => {
    const isValidPimpinan = pimpinanData.some(
      (item) => item.nama === pimpinan.nama
    );
    if (isValidPimpinan) {
      setSelectedPimpinan(pimpinan);
    }
  };

  return (
    <div className="pimpinan-container">
      <header className="header-section">
        <div className="header-content">
          <h2>PIMPINAN UPI YPTK</h2>
          <hr className="header-line" />
        </div>
      </header>

      <div className="pimpinan-kampus">
        <div className="pimpinan-list">
          {pimpinanData.map((pimpinan, index) => (
            <div
              key={index}
              className={`pimpinan-item ${
                selectedPimpinan.nama === pimpinan.nama ? "active" : ""
              }`}
              onClick={() => handlePimpinanSelect(pimpinan)}
            >
              <h3>{DOMPurify.sanitize(pimpinan.nama)}</h3>
              <h5>{DOMPurify.sanitize(pimpinan.jabatan)}</h5>
            </div>
          ))}
        </div>

        <div className="pimpinan-detail">
          <img
            src={DOMPurify.sanitize(selectedPimpinan.foto)}
            alt={DOMPurify.sanitize(selectedPimpinan.nama)}
            className="pimpinan-foto"
          />
          <h2>{DOMPurify.sanitize(selectedPimpinan.nama)}</h2>
          <h5>{DOMPurify.sanitize(selectedPimpinan.jabatan)}</h5>

          {selectedPimpinan.detail && (
            <table>
              <tbody>
                <tr>
                  <td><strong>NIDN</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.nidn)}</td>
                </tr>
                <tr>
                  <td><strong>Email</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.email)}</td>
                </tr>
                <tr>
                  <td><strong>Fakultas</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.fakultas)}</td>
                </tr>
                <tr>
                  <td><strong>Pangkat</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.pangkat)}</td>
                </tr>
                <tr>
                  <td><strong>Pekerjaan</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.pekerjaan)}</td>
                </tr>
                <tr>
                  <td><strong>Tempat/ Tanggal Lahir</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.ttl)}</td>
                </tr>
                <tr>
                  <td><strong>Scopus ID</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.scopusID)}</td>
                </tr>
                <tr>
                  <td><strong>Sinta ID</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.sintaID)}</td>
                </tr>
                <tr>
                  <td><strong>Orchid ID</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.orcidID)}</td>
                </tr>
                <tr>
                  <td><strong>Researcher ID</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.researcherID)}</td>
                </tr>
                <tr>
                  <td><strong>Pendidikan</strong></td>
                  <td>
                  <ul>
                    {selectedPimpinan.detail.riwayatPendidikan.map((item, index) => (
                      <li key={index}>{DOMPurify.sanitize(item)}</li>
                    ))}
                  </ul>
                  </td>
                </tr>
                <tr>
                  <td><strong>Mata Kuliah</strong></td>
                  <td>{DOMPurify.sanitize(selectedPimpinan.detail.mataKuliah)}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default PimpinanKampus;
